module.exports = "/newsfeed/article-b5d1a2.html";